import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'
import HeaderBrand from 'components/nav/Header/HeaderBrand'
import Header from 'components/nav/Header'
import CircleOfWaiting from 'components/shared/CircleOfWaiting'
import { Button } from '@driftt/tide-core-legacy'
import IconSVG from 'svg-inline-react'
import outreachIntermediateStepSvg from '!svg-inline!images/svg/outreach-intermidate-step.svg'
import { APP_URL } from 'constants/ResourcesConstants'


import { createAccessToken, createSlackbotToken, createSandBoxAccessToken } from 'app/modules/integrations/actions'
import { connectionsRoot, didCreateAccessToken, failedCreateAccessToken, accessTokenError } from 'app/modules/integrations/selectors'


import {
  getIsGoogleOauthConnected,
  getIsMicrosoftOauthConnected,
  hasMicrosoftAdminConsent,
  getIsGoogleOauthConnectedError,
} from 'app/modules/meetings/selectors'
import {
  googleOauthAccept as googleCalendarOauthAccept,
  microsoftOauthAccept as microsoftCalendarOauthAccept,
  microsoftAdminManagedAccept
} from 'app/modules/meetings/actions'

import style from './style.styl'

function getHubSpotData({ code }) {
  return { code }
}

const GOOGLE_CALENDAR_ERROR_PROP = 'google-calendar-error'
const GOOGLE_CALENDAR_INTEGRATION_NAME = 'google-calendar'
const MICROSOFT_CALENDAR_INTEGRATION_NAME = 'office-365-calendar'
const MICROSOFT_ADMIN_CONSENT_NAME = 'office-365-admin-consent'

export class Lander extends Component {
  state = {
    closed: false,
    displayOutreachIntermediateState: false
  }

  static contextTypes = {
    app: PropTypes.object.isRequired,
  }

  componentWillReceiveProps(nextProps) {
    const {
      params: { integration }
    } = this.props

    if (this.shouldDisplayOutreachIntermediateState(nextProps)) {
      this.setState({
        displayOutreachIntermediateState: true
      })
      return
    }

    if (nextProps.accessTokenCreated) {
      this.closeWindowAndNotify(true)
    } else if (nextProps.accessTokenCreationFailed) {
      this.closeWindowAndNotify(false, nextProps.accessTokenError)
    } else if (nextProps.statusByIntegration.has(integration)) {
      const status = nextProps.statusByIntegration.get(integration)
      this.closeWindowAndNotify(status)
    }
  }

  shouldDisplayOutreachIntermediateState(nextProps) {
    const {
      params: { integration },
      location: { query: { state } },
    } = nextProps

    if ( integration !== "outreach") {
      return false
    }

    const stateParams = state && JSON.parse(state)

    return stateParams && (nextProps.accessTokenCreated || nextProps.statusByIntegration.has("outreach")) && !stateParams.isDriftConnectedOnOutreachSide
  }

  componentDidMount() {
    const { integration } = this.props.params

    switch (integration) {
      case "hubspot":
        this.handleHubSpot()
        break
      case "outreach":
        this.handleOutreach()
        break
      case "mailchimp":
        this.handleMailChimp()
        break
      case "segment":
        this.handleSegment()
        break
      case "drip":
        this.handleDrip()
        break
      case "wordpress":
        this.handleWordpress()
        break
      case "slack":
        this.handleSlack()
        break
      case "salesforce":
        this.handleSalesforce()
        break
      case "salesforceSandbox":
        this.handleSalesforceSandbox()
        break
      case "zendesk":
        this.handleZendesk()
        break
      case GOOGLE_CALENDAR_INTEGRATION_NAME:
        this.handleGoogleCalendar()
        break
      case MICROSOFT_CALENDAR_INTEGRATION_NAME:
        this.handleMicrosoftCalendar()
        break
      case MICROSOFT_ADMIN_CONSENT_NAME:
        this.handleMicrosoftAdminConsent()
        break

    }
  }

  closeWindowAndNotify = (status, error = '') => {
    this.setState({ closed: true }, () => {
      window.opener && window.opener.postMessage({ status: status ? 'success' : 'failure', errormessage: error }, window.location.origin)
      window.close()
    })
  }

  handleSlack() {
    const { code } = this.props.location.query
    this.props.actions.createSlackbotToken({ code, href: `${window.location.origin}${window.location.pathname}` })
  }

  handleMailChimp() {
    const { pathname, origin } = window.location
    const update = {
      code: this.props.location.query.code,
      redirectUrl: `${origin}${pathname}`
    }
    this.props.actions.createAccessToken({ integrationName: 'mailchimp', body: update })
  }

  handleDrip() {
    const update = {
      code: this.props.location.query.code,
    }
    this.props.actions.createAccessToken({ integrationName: 'drip', body: update })
  }

  handleSalesforce() {
    const update = {
      code: this.props.location.query.code,
      error: this.props.location.query.error
    }
    this.props.actions.createAccessToken({ integrationName: 'salesforce', body: update })
  }

  handleSalesforceSandbox() {
    const update = {
      code: this.props.location.query.code,
      sandbox: true
    }
    this.props.actions.createSandBoxAccessToken({ integrationName: 'salesforceSandbox', body: update })
  }

  handleWordpress() {
    const update = {
      code: this.props.location.query.code,
    }
    this.props.actions.createAccessToken({ integrationName: 'wordpress', body: update })
  }

  handleOutreach() {
    const update = {
      code: this.props.location.query.code,
    }
    this.props.actions.createAccessToken({ integrationName: 'outreach', body: { ...update, redirectUri: `${APP_URL}/accept-integration/outreach` } })
  }


  handleZendesk() {
    const update = {
      code: this.props.location.query.code,
      accountName: this.props.location.query.state
    }
    this.props.actions.createAccessToken({ integrationName: 'zendesk', body: update })
  }

  handleHubSpot() {
    const update = getHubSpotData(this.props.location.query)
    this.props.actions.createAccessToken({ integrationName: 'hubspot', body: update })
  }

  handleSegment() {
    // segment does nothing but posting a message done
    setTimeout(function () {
      window.opener.postMessage('DONE', window.location.origin)
      window.close()
    }, 3000
    )
  }

  handleGoogleCalendar() {
    const code = this.props.location.query.code
    this.props.actions.googleCalendarOauthAccept(code)
  }

  handleMicrosoftCalendar() {
    const code = this.props.location.query.code
    this.props.actions.microsoftCalendarOauthAccept(code)
  }

  handleMicrosoftAdminConsent() {
    const tenant = this.props.location.query.tenant

    if (!!tenant) {
      this.props.actions.microsoftAdminManagedAccept(tenant)
    }
  }
  
  render() {
    const { displayOutreachIntermediateState } = this.state
    return (displayOutreachIntermediateState ?
      <div className="outreach-intermidate-step">
        <IconSVG src={outreachIntermediateStepSvg} className="outreach-intermidate-step-svg" />
        <h3>Continue to connect Drift in Outreach</h3>
        <div className="outreach-intermidate-step-copy"><p> Just connect Drift in Outreach and you’ll be able to unenroll contacts or create a task when a new Drift conversation is started from a sequence. </p></div>
        <Button type="primary" href="https://accounts.outreach.io/apps/drift/install"> Connect Drift in Outreach </Button>
      </div>
      :
      <Header title="Integration"
        showTitle={false}
        showClose={false}
        leftNav={<HeaderBrand />}
      >
        <div className={`flex-center flex-column ${style.AcceptIntegrate}`}>
          <div className="dsg-h1">
            Accepting permissions
            <CircleOfWaiting />
          </div>
          <p>Please give us a few moments while we hook it up for you</p>
        </div>
      </Header>
    )
  }
}

function mapStateToProps(state, props) {
  const integrationName = props.params.integration || ''

  return {
    statusByIntegration: Map({
      [GOOGLE_CALENDAR_INTEGRATION_NAME]: getIsGoogleOauthConnected(state),
      [MICROSOFT_CALENDAR_INTEGRATION_NAME]: getIsMicrosoftOauthConnected(state),
      [GOOGLE_CALENDAR_ERROR_PROP]: getIsGoogleOauthConnectedError(state),
      [MICROSOFT_ADMIN_CONSENT_NAME]: hasMicrosoftAdminConsent(state),
      ...connectionsRoot(state)
    }),
    accessTokenCreated: didCreateAccessToken(state, integrationName),
    accessTokenCreationFailed: failedCreateAccessToken(state, integrationName),
    accessTokenError: accessTokenError(state, integrationName),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      googleCalendarOauthAccept,
      microsoftCalendarOauthAccept,
      microsoftAdminManagedAccept,
      createAccessToken,
      createSlackbotToken,
      createSandBoxAccessToken
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Lander)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/Lander/index.js